import request from '@/utils/request'
import qs from 'qs'


export function loginApi(params) {
  return request({
    url: '/api/student/login',
    method: 'post',
    data: qs.stringify({
		...params
	})
  })
}

export function getStudentInfoApi(params) {
  return request({
    url: '/api/student/getStudentInfo',
    method: 'get',
    params: params
  })
}


export function getRoomTurnApi(params) {
  return request({
    url: 'api/blindBoxRoom/getRoomTurn',
    method: 'post',
    data: params
  })
}

export function copyrightApi(params) {
  return request({
    url: '/api/basis/getConfigInfo',
    method: 'get',
    params: {
		key:'copyright',
		...params
	}
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js